<div class="container cl-form cl-spacing-small" [formGroup]="poFormGroup">
  @if (airlines().length == 1) {
    <input type="hidden" formControlName="airline" [value]="airlines()[0].iata_code">
  }
  <div class="row">
    @if (airlines().length > 1) {
      <div class="col-4">
        <label for="airline" class="form-label">Airline<span class="required">*</span></label>
        <select id="airline" class="form-select" formControlName="airline">
          @for (airline of airlines(); track airline) {
            <option [value]="airline.iata_code"> {{ airline.airline_name }}
              ({{ airline.iata_code }})
            </option>
          }
        </select>
        @if (poFormGroup.controls.airline.errors?.required) {
          <p class="invalid-feedback">This field is required.</p>
        }
        @if (!poFormGroup.controls.airline.errors) {
          <p class="valid-feedback">Selects the airline on Castlabs' side.</p>
        }
      </div>
    }


    <div [class.col-4]="airlines().length > 1" [class.col-8]="airlines().length === 1">
      <label for="po_number" class="form-label">PO Name<span class="required">*</span></label>
      <input id="po_number" type="text" formControlName="po_number" maxlength="128" >
      @if (poFormGroup.controls.po_number.errors?.required) {
        <p class="invalid-feedback">This field is
        required.</p>
      }
      @if (poFormGroup.controls.po_number.errors?.pattern) {
        <p class="invalid-feedback">{{ this.ifeFormat.po_pattern.pattern_description }}</p>
      }
      @if (!poFormGroup.controls.po_number.errors) {
        <p class="valid-feedback">The encoding PO number for later
        reference</p>
      }
    </div>
    <div class="col-4">
      <label for="email_notification" class="form-label">Email Notification</label>
      <input id="email_notification" type="text" formControlName="email_notification">
      @if (poFormGroup.controls.email_notification.errors?.required) {
        <p class="invalid-feedback">This field is
        required.</p>
      }
      @if (poFormGroup.controls.email_notification.errors?.email) {
        <p class="invalid-feedback">Please insert a valid
        email.</p>
      }
      @if (!poFormGroup.controls.email_notification.errors) {
        <p class="valid-feedback">A notification email will be
        sent to this address</p>
      }
    </div>
    <div class="col-4">
      <label for="email_notification_publish" class="form-label">Publish Notification Email</label>
      <input id="email_notification_publish" type="text" formControlName="email_notification_publish">
      @if (poFormGroup.controls.email_notification_publish.errors?.email) {
        <p class="invalid-feedback">Please insert a valid
        email.</p>
      }
      @if (!poFormGroup.controls.email_notification_publish.errors) {
        <p class="valid-feedback">Receives delivery report on
        publish success</p>
      }
    </div>
    <div class="col-4 ">
      <label for="ife" class="form-label">Target System<span class="required">*</span></label>
      <select id="ife" class="form-select" formControlName="ife" [compareWith]="compare_item_id">
        @for (sys of availableSystems; track sys) {
          <option [value]="sys.item_id">{{ sys.item_text }}</option>
        }
      </select>
      @if (poFormGroup.controls.ife.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (!poFormGroup.controls.ife.errors) {
        <p class="valid-feedback">Select the IFE system.</p>
      }

    </div>

    <div class="col-4 ">
      <label for="ife_format" class="form-label">Target Format<span class="required">*</span></label>
      <select id="ife_format" class="form-select" formControlName="ife_format" [compareWith]="compare_item_id">
        @for (sys of ifeFormats; track sys) {
          <option [value]="sys.item_id">{{ sys.item_text }}</option>
        }
      </select>
      @if (poFormGroup.controls.ife_format.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (!poFormGroup.controls.ife_format.errors) {
        <p class="valid-feedback">Select the desired format.</p>
      }
    </div>

    <div class="col-4 ">
      <label for="po_destination" class="form-label">Delivery Destination<span class="required">*</span></label>
      <select id="po_destination" class="form-select" formControlName="po_destination"
        [compareWith]="compare_destination_id">
        @for (sys of poDestinations; track sys) {
          <option [value]="sys.destination_id" [disabled]="sys.enabled == false ">{{ sys.display_name }}</option>
        }
      </select>
      @if (poFormGroup.controls.po_destination.errors?.required) {
        <p class="invalid-feedback">This field is
        required.</p>
      }
      @if (!poFormGroup.controls.po_destination.errors) {
        <p class="valid-feedback">Select the desired destination.</p>
      }
    </div>

    <div class="col-4 ">
      <label for="auto_publish" class="form-label">Publication</label>
      <select id="auto_publish" class="form-select" formControlName="auto_publish">
        <option [value]="true"> Automatic Publication
        </option>
        <option [value]="false"> Manual Publication
        </option>
      </select>
      <p class="valid-feedback">Manual Publication allows for a final QA step before distributing the content, whereas Automatic Publication releases the content immediately upon readiness.</p>
    </div>
    @if (poFormGroup.controls.westent_cycle_name) {
      <div class="col-4"
        >
        <label for="westent_cycle_name" class="form-label">WestEnt Cycle Name</label>
        <input id="westent_cycle_name" type="text" formControlName="westent_cycle_name">
        @if (poFormGroup.controls.westent_cycle_name.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!poFormGroup.controls.westent_cycle_name.errors) {
          <p class="valid-feedback">Required for WestEnt to
          determine correct delivery location</p>
        }
      </div>
    }
    <!-- Lilt: PO-level source/domain. Target languages are picked per item. -->
    @if (poFormGroup.controls.lilt_src_lang) {
      <div class="col-2">
        <label for="lilt_src_lang" class="form-label">Source Language</label>
        <input id="lilt_src_lang" type="text" class="form-control" formControlName="lilt_src_lang" readonly>
        <p class="valid-feedback">Currently only "en" is supported.</p>
      </div>
    }
    @if (poFormGroup.controls.lilt_src_locale) {
      <div class="col-2">
        <label for="lilt_src_locale" class="form-label">Source Locale</label>
        <input id="lilt_src_locale" type="text" class="form-control" formControlName="lilt_src_locale" readonly>
        <p class="valid-feedback">Currently only "US" is supported.</p>
      </div>
    }
    @if (poFormGroup.controls.lilt_domain_id) {
      <div class="col-8 align-self-start">
        <label for="lilt_domain_id" class="form-label">Lilt Domain<span class="required">*</span></label>
        <select id="lilt_domain_id" class="form-select" formControlName="lilt_domain_id"
                (change)="onLiltDomainChange()">
          <option [ngValue]="null">[Select a Lilt domain]</option>
          @for (d of liltDomains; track d.domain_id) {
            <option [ngValue]="d.domain_id">{{ d.name }} (id: {{ d.domain_id }})</option>
          }
        </select>
        @if (poFormGroup.controls.lilt_domain_id.errors?.required) {
          <p class="invalid-feedback">Pick a Lilt domain.</p>
        } @else if (!poFormGroup.controls.lilt_domain_id.errors) {
          <p class="valid-feedback">Auto-selected by airline marker when available; pick another if needed.</p>
        }
      </div>
    }
    @if (poFormGroup.controls.lilt_due_date) {
      <div class="col-4">
        <label for="lilt_due_date" class="form-label">Due Date</label>
        <input id="lilt_due_date" type="date" class="form-control" formControlName="lilt_due_date">
        <p class="valid-feedback">Optional. Sent to Lilt as the job due date when set.</p>
      </div>
    }
    @if (poFormGroup.controls.lilt_job_instructions) {
      <div class="col-12">
        <div class="form-check">
          <input id="lilt_source_review_required" type="checkbox" class="form-check-input"
                 [checked]="poFormGroup.controls.lilt_source_review_required?.value"
                 (change)="onLiltSourceReviewToggle($any($event.target).checked)">
          <label for="lilt_source_review_required" class="form-check-label">Source review required</label>
        </div>
        <label for="lilt_job_instructions" class="form-label">Job Instructions<span class="required">*</span></label>
        <textarea id="lilt_job_instructions" class="form-control" rows="3" maxlength="5000"
                  formControlName="lilt_job_instructions"></textarea>
        @if (poFormGroup.controls.lilt_job_instructions.errors?.required) {
          <p class="invalid-feedback">Enter job instructions for Lilt translators.</p>
        } @else if (poFormGroup.controls.lilt_job_instructions.errors?.maxlength) {
          <p class="invalid-feedback">Instructions must be 5000 characters or fewer.</p>
        } @else {
          <p class="valid-feedback">Seeded from the checkbox; edit as needed. Sent to Lilt as `jobInstructions`.</p>
        }
      </div>
    }
  </div>

  <ng-container formArrayName="poItems">
    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx"
        >
        <div class="row cl-spacing-small">
          <div class="col-12">
            <h3 [class.warn]="poItems.controls[idx].invalid">{{ poItems.controls[idx].value['basics']['po_item_id'] }}
              <button class="cl-a-quickaction" (click)="poService.removePOItem(poItems.controls[idx].value['id'])">
                Remove
              </button>
            </h3>
          </div>
        </div>
        <input id="idinput" type="hidden" formControlName="id">
        <app-basic-poitem-info
          formControlName="basics"
          [organization]="organization()"
          [ife_format]="ifeFormat"
          (pasteFilenames)="handlePasteFilenames($event, idx)"
          [id]="poItems.controls[idx].value['id']">
        </app-basic-poitem-info>
        <app-track-selection
          formControlName="tracks">
        </app-track-selection>
        <app-default-specific formControlName="above_specific"
        [ife_format]="ifeFormat"></app-default-specific>
        <app-default-format-specific formControlName="format_specific_data"
        [ifeFormat]="ifeFormat"
        [poDestination]="poFormGroup.controls['po_destination'].value"
        [liltDomain]="selectedLiltDomain"></app-default-format-specific>
        <div class="row">
          <div class="col-12">
            <hr class="cl-spacing-small">
          </div>
        </div>
      </ng-container>
    }
  </ng-container>
  <div class="row cl-spacing-small">
    <div class="col-12" style="display: flex; flex-direction: row; justify-content: space-between;">
      <div style="flex-grow: 1; display: flex; gap: 16px">
        <input  type="file" hidden #fileinput (change)="load($event)">
        <button class="btn btn-sm cl-btn-outline-text" (click)="fileinput.click()">Load PO</button>
        <button class="btn btn-sm cl-btn-outline-text" (click)="downloadPO()">Save PO</button>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; gap: 16px;">
        <app-message-field #encodeMessage/>
        <app-do-button  [messageField]="encodeMessage" (actionTriggered)="submit_po($event)"><span>Start Encode</span><i
      class="fas fa-angle-right"></i></app-do-button>

    </div>
  </div>
</div>

</div>
